module.exports = __webpack_public_path__ + "static/img/al5.67f8c25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al5.jpg
// module id = loEU
// module chunks = 1